module.exports = __webpack_public_path__ + "img/tap_store.6520fd1.png";